<template>
	<div class="ForgotPassword">
		<div class="login-card">
			<div class="card-background">
				<h1 class="login-header">
					Set Password
				</h1>
				<div
					class="form-group1 w-95p inline-block"
					:class="{ 'not-empty1': new_password.length }"
				>
					<input
						v-model="new_password"
						v-validate.bails="'required|min:8|verify_password'"
						type="password"
						class="form-control1"
						name="New Password"
					/>
					<label for="user" class="animated-label1">
						New Password
					</label>
				</div>
				<div
					class="password-info"
					title="The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc) and password must be at least 8 characters"
				>
					<span class="el-icon-info" style="cursor:pointer" />
				</div>
				<span class="text-red-dark text-xs">
					{{ errors.first("New Password") }}
				</span>
				<div
					class="form-group1 w-95p"
					:class="{ 'not-empty1': confirm_password.length }"
				>
					<input
						v-model="confirm_password"
						v-validate.bails="'required|min:8|verify_password'"
						type="password"
						class="form-control1"
						name="Confirm Password"
					/>
					<label for="user" class="animated-label1">
						Confirm Password
					</label>
				</div>
				<span class="text-red-dark text-xs">
					{{ errors.first("Confirm Password") }}
				</span>
				<div class="Confirm-btn-section">
					<button class="confirm-button" @click="confirmPassword()">
						Confirm
					</button>
				</div>
				<p class="cancel" @click="redirectToLoginPage">
					Cancel
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { serverAddr } from "../../networkConfig";
import { ForgotPasswordNC } from "../../../mixins/ForgotPasswordNC";
export default {
	name: "ForgotPassword",
	mixins: [ForgotPasswordNC],
	props: [],
	data() {
		return {
			new_password: "",
			confirm_password: "",
			uid: this.$route.query.uid,
			token: this.$route.query.token
		};
	},
	mounted() {
		console.log("uid", this.uid);
		console.log("token", this.token);
	},
	methods: {
		redirectToLoginPage() {
			this.$router.push({ path: "/login-and-free-trial" }).catch(()=>{});
		},
		// confirmPassword() {
		// 	console.log(this.new_password);
		// 	console.log(this.confirm_password);
		// 	if (this.new_password !== this.confirm_password) {
		// 		this.$notify.error({
		// 			title: "Error",
		// 			message: "Passwords do not Match"
		// 		});
		// 	}
		// 	if (this.new_password === "" && this.confirm_password === "") {
		// 		this.$notify.error({
		// 			title: "Error",
		// 			message: "Please enter password"
		// 		});
		// 	}
		// },
		confirmPassword() {
			if (this.new_password !== this.confirm_password) {
				this.$notify.error({
					title: "Error",
					message: "Password mismatch Please re-enter the password"
				});
			} else {
				this.$validator.validateAll().then(result => {
					if (result) {
						serverAddr
							.post("/users/activate/", {
								uid: this.uid,
								token: this.token,
								password: this.new_password
							})
							.then(this.postForgotPassword)
							.catch(error => {
								console.log("error.response.data", error.response);
								console.log(
									"ddddd",
									JSON.parse(error.response.data).password[0]
								);
								this.$notify.error({
									title: "Error",
									message: JSON.parse(error.response.data).password[0],
									type: "Error"
								});
							});
						// .catch(function(error) {

						// 	console.log(error);
						// });
					}
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./ForgotPassword.scss";
</style>
<style>
.el-notification {
	z-index: 9999 !important;
}
</style>
